import { API_URL } from "../../config/connect";

export async function createDemand(demandData, accessToken) {
    try {
        if (!accessToken) {
            console.error("Access token not found. User is not authenticated.");
            throw new Error("Authentication required: Access token not found.");
        }

        const response = await fetch(`${API_URL}/api/v1/demands`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(demandData),
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => response.text());
            const errorMsg = typeof errorData === 'object' ? errorData.detail?.message || errorData.message || JSON.stringify(errorData) : errorData;
            throw new Error(`Error: ${response.status} ${response.statusText}, Details: ${errorMsg}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error creating demand:", error);
        throw error;
    }
}

